import {GtPhoneNumberUtil} from './gt-phone-number.util';

export class PhoneAndNameFormatUtil {

  static toDisplay(cnumber: string, name: string) {
    return name +  ' (' + GtPhoneNumberUtil.toDisplay(cnumber) + ')';
  }
}
